import endpoint from '../../features/endPoints/ecommEndpoints';
import BaseClient from '../base/baseClient';

import {parseIfJson} from "../../utils/parser";

const cancelSalesAgreementNewClient = (salesAgrNum, CancelReason) => {
    const { put: putClient } = BaseClient();

    const requestBody = mapRequest(CancelReason);
    return putClient(
        endpoint.cancelSalesAgreementNew(salesAgrNum),
        requestBody,
        {},
        true
    );
};

//map body to request body as per API
const mapRequest = (CancelReason) => {
  CancelReason = parseIfJson(CancelReason);
  var bodyData = {
    "cancelReasonCode": CancelReason && CancelReason.name?CancelReason.name:"",
    "notes": [
        "Self service cancel of this SA by the Customer on Web/App."
    ]
  };

  return bodyData;
};

//map response to object needed by React view
const mapResponse = (response) => {
  return response;
};

//map error to object needed by React view
const mapError = (error) => {
  return error;
};

export default cancelSalesAgreementNewClient;